import RentalFormModal from "../common/Rentals/RentalFormModal";

const ADD_PROPERTY_GUIDE_CONFIG = {
  showDestinationField: true,
  showLatLng: true,
  showGuideName: true,
  title: "a Home Guide",
  defaultDestinationId: 0,
  showLogs: false,
  messageOnAdd: "Added Successfully",
  messageOnEdit: "Updated Successfully",
  redirectPath: "/properties/{id}",
};

const AddPropertyGuide = () => {
  return <RentalFormModal config={ADD_PROPERTY_GUIDE_CONFIG} />;
};

export default AddPropertyGuide;
